<template>
  <div>
    <tr>
      <td colspan="3">{{ depName }}</td>
    </tr>
    <tr v-for="(item, index) in depInvoices" :key="item.id">
      <td>{{ item.amount }}</td>
      <td>{{ item.amount }}</td>
      <td>{{ item.amount }}</td>
    </tr>
  </div>
</template>



<script>
export default {
  props: ["depName", "depInvoices"],
};
</script>